import {Box, Dialog, DialogContent, DialogProps, Stack} from "@mui/material";
import {useQuery} from "react-query";
import {ImportLogService} from "crqlar-react-common/dist/services/integrations/importLog.service";
import React from "react";
import Typography from "@mui/material/Typography";
import {useTranslation} from "react-i18next";
import {formatDateDMYHM} from "crqlar-react-common/dist/utils/date.util";

interface ImportLogPreviewDialogProps extends DialogProps {
    importLogId?: string;
}

const ImportLogPreviewDialog = (props: ImportLogPreviewDialogProps) => {

    const {t} = useTranslation()

    const importLogQuery = useQuery(['importLog', props.importLogId], () => {
        if (props.importLogId) {
            return ImportLogService.getById(props.importLogId);
        }
        return Promise.resolve(null);
    })
    const importLog = importLogQuery.data;

    let uiContent = null;
    if (importLogQuery.isLoading) {
        uiContent = <div>{t('Loading')}</div>;
    } else if (importLogQuery.isError) {
        uiContent = <div>{t('Error')}</div>;
    } else if (!importLog) {
        uiContent = <div>{t('No data')}</div>;
    } else {
        uiContent = (
            <Stack gap={1}>

                <Stack direction={'row'} gap={1}>
                    <Typography sx={{minWidth: 150}}>
                        {t('Source')}:
                    </Typography>
                    <Typography sx={{fontWeight: 'bold'}}>
                        {importLog.source}
                    </Typography>
                </Stack>

                <Stack direction={'row'} gap={1}>
                    <Typography sx={{minWidth: 150}}>
                        {t('Status')}:
                    </Typography>
                    <Typography sx={{fontWeight: 'bold'}}>
                        {importLog.status}
                    </Typography>
                </Stack>

                <Stack direction={'row'} gap={1}>
                    <Typography sx={{minWidth: 150}}>
                        {t('Processing start')}:
                    </Typography>
                    <Typography sx={{fontWeight: 'bold'}}>
                        {formatDateDMYHM(importLog.processingStart)}
                    </Typography>
                </Stack>

                <Stack direction={'row'} gap={1}>
                    <Typography sx={{minWidth: 150}}>
                        {t('Processing done')}:
                    </Typography>
                    <Typography sx={{fontWeight: 'bold'}}>
                        {formatDateDMYHM(importLog.processingDone)}
                    </Typography>
                </Stack>

                <Stack direction={'row'} gap={1}>
                    <Typography sx={{minWidth: 150}}>
                        {t('Content category')}:
                    </Typography>
                    <Typography sx={{fontWeight: 'bold'}}>
                        {importLog.contentCategory}
                    </Typography>
                </Stack>

                <Stack direction={'row'} gap={1}>
                    <Typography sx={{minWidth: 150}}>
                        {t('Async ACK status')}:
                    </Typography>
                    <Typography sx={{fontWeight: 'bold'}}>
                        {importLog.asyncAckStatus}
                    </Typography>
                </Stack>

                <Stack gap={0.5}>
                    <Typography sx={{minWidth: 150}}>
                        {t('Content')}:
                    </Typography>
                    <Box
                        sx={{
                            whiteSpace: 'pre-wrap',
                            fontSize: '0.8rem',
                            border: '1px solid #ccc',
                            padding: 1,
                            maxWidth: '100%',
                            overflow: 'auto',
                            wordBreak: 'break-word' // Breaks long words to prevent overflow

                        }}
                    >
                        {importLogQuery.data?.content}
                    </Box>
                </Stack>

                <Stack gap={0.5}>
                    <Typography sx={{minWidth: 150}}>
                        {t('Trace')}:
                    </Typography>
                    <Box
                        sx={{
                            whiteSpace: 'pre-wrap',
                            fontSize: '0.8rem',
                            border: '1px solid #ccc',
                            padding: 1
                        }}
                    >
                        {importLogQuery.data?.message}
                    </Box>
                </Stack>

                <Stack gap={0.5}>
                    <Typography sx={{minWidth: 150}}>
                        {t('Response')}:
                    </Typography>
                    <Box
                        sx={{
                            whiteSpace: 'pre-wrap',
                            fontSize: '0.8rem',
                            border: '1px solid #ccc',
                            padding: 1
                        }}
                    >
                        {importLogQuery.data?.response}
                    </Box>
                </Stack>

            </Stack>
        )
    }

    return (
        <Dialog
            open={props.open}
            onClose={props.onClose}
            fullWidth
            maxWidth={'lg'}
        >
            <DialogContent>
                {uiContent}
            </DialogContent>
        </Dialog>
    )

}

export default ImportLogPreviewDialog;